var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.5C8 5.15685 6.65685 6.5 5 6.5C3.34315 6.5 2 5.15685 2 3.5C2 1.84315 3.34315 0.5 5 0.5C6.65685 0.5 8 1.84315 8 3.5ZM5 7.49997C2.23858 7.49997 0 9.73857 0 12.5C0 12.7761 0.223858 13 0.5 13H9.5C9.77614 13 10 12.7761 10 12.5C10 9.73857 7.76142 7.49997 5 7.49997ZM13.5001 13H11.1776C11.2248 12.8416 11.2501 12.6737 11.2501 12.5C11.2501 10.4589 10.2717 8.64634 8.75832 7.50571C8.83843 7.5019 8.91903 7.49997 9.00008 7.49997C11.7615 7.49997 14.0001 9.73857 14.0001 12.5C14.0001 12.7761 13.7762 13 13.5001 13ZM9.00008 6.5C8.69835 6.5 8.40703 6.45545 8.13233 6.37258C8.82642 5.61615 9.25008 4.60755 9.25008 3.5C9.25008 2.39245 8.82642 1.38385 8.13232 0.62741C8.40703 0.54454 8.69835 0.5 9.00008 0.5C10.6569 0.5 12.0001 1.84315 12.0001 3.5C12.0001 5.15685 10.6569 6.5 9.00008 6.5Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.329cf96f855fd3265991de93a64a23c0.svg";
export { ForwardRef as ReactComponent };